import index from "./detail.vue";
export default index;
